// Copyright (c) Ping. All rights reserved.
import type { PaneSection } from '@features/onboarding/tour/paneGuideTypes';

export const encryptionSections: PaneSection[] = [
  {
    section: 'overview',
    title: 'Encryption',
    body: 'Every chat on Ping is end to end encrypted, so only you and the people you are talking to can read your messages. This is where you can check on it.',
  },
  {
    section: 'end-to-end',
    title: 'Always protected',
    body: 'End to end encryption is always on and you cannot turn it off. Ping itself can never read what you send.',
  },
  {
    section: 'devices',
    title: 'Your devices',
    body: 'Here you can see every device signed in to your account. Look through the list and make sure you recognize each one.',
  },
];
